var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Guid } from "../../../utilities/guid";
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
var Switch = /** @class */ (function () {
    function Switch(element) {
        this.element = element;
        this.identifier = Guid.generateGuid();
    }
    Switch.prototype.attached = function () {
        //Disableds TabIndex when Disabled or Readonly
        if (this.disableInput || this.disabled || this.readonly) {
            this.tab = -1;
        }
        if (this.label) {
            this.onKeyDownDelegate = this.onKeyDown.bind(this);
            this.label.addEventListener("keydown", this.onKeyDownDelegate, false);
        }
    };
    Switch.prototype.detached = function () {
        if (this.label) {
            this.label.removeEventListener("keydown", this.onKeyDownDelegate, false);
        }
    };
    Switch.prototype.onKeyDown = function (event) {
        var code = event.keyCode;
        if (code === 32) {
            this.onClick(event);
            event.preventDefault();
        }
    };
    Switch.prototype.onClick = function ($event) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
        }
        setTimeout(function () {
            _this.check();
        });
    };
    Switch.prototype.disabledChanged = function () {
        if (this.disabled) {
            this.tab = -1;
        }
        else {
            this.tab = 0;
        }
    };
    Switch.prototype.check = function () {
        if (this.readonly || this.disabled || this.disableInput) {
            return;
        }
        this.checked = !this.checked;
        var changeEvent = new CustomEvent("changed", {
            detail: {
                value: this.checked
            },
            bubbles: true
        });
        this.element.dispatchEvent(changeEvent);
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Switch.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Switch.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Switch.prototype, "checked", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Switch.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Switch.prototype, "disableInput", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Switch.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Switch.prototype, "tab", void 0);
    Switch = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], Switch);
    return Switch;
}());
export { Switch };
